import React from 'react';
import ReactDOM from 'react-dom/client';

// import { BrowserRouter } from "react-router-dom";
import Approuter from './approuter';

// import { App } from "./app";
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/bootstrap.min.css';
//CSS & Bootstrap
import './assets/css/style.css';
import './assets/js/bootstrap.bundle.min.js';
import './assets/css/select2.min.css';
//Font Awesome
import './assets/plugins/fontawesome/css/fontawesome.min.css';
import './assets/plugins/fontawesome/css/all.min.css';
import store from './store';
import { Provider } from 'react-redux';

import amplifyConfig from './aws-config/aws-config.js';
import { Amplify, Auth } from 'aws-amplify';
import { ConfigProvider } from 'antd';
import { AvailableAppLocales } from './availableAppLocales.js';
import InActivityTracker from './components/InActivityTracker';
Amplify.configure({ Auth: { amplifyConfig } });
Auth.configure(amplifyConfig);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <ConfigProvider
      locale={AvailableAppLocales.enUS}
      theme={{
        token: {
          colorPrimary: '#4e57cd',
          colorInfo: '#4e57cd',
        },
        components: {
          Button: {
            colorPrimaryHover: '#03318C',
            defaultShadow: '0 2px 0 rgba(0, 0, 0, 0.02)',
            primaryShadow: '0 2px 0 rgba(5, 145, 255, 0.1)',
          },
        },
      }}
    >
      <InActivityTracker>
        <Approuter />
      </InActivityTracker>
    </ConfigProvider>
  </Provider>
);
// ReactDOM.render(
//     <BrowserRouter>
//       <Approuter />
//     </BrowserRouter>,
//     document.getElementById("root")
//   );

// ReactDOM.render(
//   <Approuter/>,
// document.getElementById('root')
// );
